<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base class="cart-overview" :busy="loadingCart">
        <template v-slot:default="props">
            <pb-body>
                <template slot="title">
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-center">
                            <h3>Checkout</h3>
                            <hr/>
                        </b-col>
                    </b-row>
                </template>
                <template slot="body">
                    <b-container v-bind:class="[{ busy: busy }, 'opacity-transition']" v-if="cart">
                        <b-row class="my-2" v-if="submitError">
                            <b-col>
                                <b-alert variant="danger" show>{{submitError}}</b-alert>
                            </b-col>
                        </b-row>
                        <pb-spinner v-if="busy"/>
                        <b-row>
                            <b-col lg="4">
                                <div class="bg-gray p-4">
                                    <b-row>
                                        <b-col>
                                            <h4>BILLING ADDRESS</h4>
                                            {{user.firstName}} {{user.lastName}}
                                            <br/>
                                            {{user.externalData.company.companyName}}<br/><br/>
                                            {{user.externalData.company.street}}<br/>
                                            {{user.externalData.company.country}}-{{user.externalData.company.zipCode}}
                                            {{user.externalData.company.city}}
                                        </b-col>
                                    </b-row>
                                    <b-row class="my-3">
                                        <b-col>
                                            <h4>DELIVERY ADDRESS</h4>
                                            <b-form-checkbox v-model="deliveryAddressSameAsBilling"
                                                             true-value="true"
                                                             false-value="false">Same as Billing Address
                                            </b-form-checkbox>
                                            <b-form v-if="deliveryAddressSameAsBilling === false">
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <label for="deliveryAddress_recipient">Recipient:</label>
                                                        <b-form-input
                                                                id="deliveryAddress_recipient"
                                                                name="deliveryAddress_recipient"
                                                                type="text"
                                                                v-model.trim="deliveryAddress.recipient"
                                                                v-validate="'required'"
                                                                placeholder="Company or Personal"
                                                                :state="validateState('deliveryAddress_recipient')"
                                                        ></b-form-input>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <b-form-input
                                                                id="deliveryAddress_recipient_secondary"
                                                                name="deliveryAddress_recipient_secondary"
                                                                type="text"
                                                                v-model.trim="deliveryAddress.recipientSecondary"
                                                                placeholder="Additional Recipient Info"
                                                        ></b-form-input>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <label for="deliveryAddress_street">Street:</label>
                                                        <b-form-input
                                                                id="deliveryAddress_street"
                                                                name="deliveryAddress_street"
                                                                type="text"
                                                                placeholder="Street and House Nr."
                                                                v-model.trim="deliveryAddress.street"
                                                                v-validate="'required'"
                                                                :state="validateState('deliveryAddress_street')"
                                                        ></b-form-input>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <label for="deliveryAddress_zip">Zip Code:</label>
                                                        <b-form-input
                                                                id="deliveryAddress_zip"
                                                                name="deliveryAddress_zip"
                                                                type="text"
                                                                v-model.trim="deliveryAddress.zipCode"
                                                                v-validate="'required'"
                                                                placeholder="Zip Code"
                                                                :state="validateState('deliveryAddress_zip')"
                                                        ></b-form-input>
                                                    </b-col>
                                                    <b-col>
                                                        <label for="deliveryAddress_city">City:</label>
                                                        <b-form-input
                                                                id="deliveryAddress_city"
                                                                name="deliveryAddress_city"
                                                                type="text"
                                                                v-model.trim="deliveryAddress.city"
                                                                v-validate="'required'"
                                                                placeholder="City"
                                                                :state="validateState('deliveryAddress_city')"
                                                        ></b-form-input>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <label for="deliveryAddress_country">Country:</label>
                                                        <v-select id="deliveryAddressCountrySelect"
                                                                  :clearable="false"
                                                                  name="deliveryAddressCountrySelect"
                                                                  placeholder="Please select..."
                                                                  v-validate="'required'"
                                                                  :class="{ 'is-invalid': errors.has('deliveryAddressCountrySelect') }"
                                                                  v-model="deliveryAddress.country"
                                                                  label="name"
                                                                  :options="countryList">
                                                        </v-select>
                                                    </b-col>
                                                </b-row>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                            <b-col lg="4">
                                <div class="bg-gray p-4">
                                    <b-row>
                                        <b-col>
                                            <h4>ORDER OVERVIEW</h4>
                                            <div :key="itemId" v-for="(itemId) in cart.shoppingCartItemList">
                                                <checkout-cart-item :item="itemArray[itemId]"></checkout-cart-item>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <b>Total</b>
                                        </b-col>
                                        <b-col class="text-right">
                                            <b>{{total | currency($currencyFormatting[currency])}}</b>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                            <b-col lg="4">
                                <div class="bg-gray p-4">
                                    <b-row>
                                        <b-col>
                                            <h4>SEASON</h4>
                                            <v-select
                                                    id="season"
                                                    name="season"
                                                    :searchable="false"
                                                    :clearable="false"
                                                    v-model="selectedSeason"
                                                    label="description"
                                                    placeholder="Please select..."
                                                    v-validate="'required'"
                                                    v-bind:class="[{'is-invalid': errors.has('season')}]"
                                                    :options="seasonList">
                                            </v-select>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div class="bg-gray p-4 mt-3">
                                    <b-row>
                                        <b-col>
                                            <h4>DELIVERY DATE</h4>
                                            <b-form-datepicker

                                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                    locale="en" id="preferredDeliveryDate" name="preferredDeliveryDate" :min="new Date()"
                                                    v-validate="'required'"
                                                    v-model="preferredDeliveryDate" class="mb-2 "></b-form-datepicker>
                                        </b-col>
                                    </b-row>
                                </div>

                                <div class="bg-gray p-4 mt-3">
                                    <b-row>
                                        <b-col>
                                            <h4>COMMENT
                                                <small>(Optional)</small>
                                            </h4>
                                            <b-form-textarea
                                                    id="comment"
                                                    name="comment"
                                                    class="h-auto"
                                                    v-model="orderComment"
                                                    rows="4"
                                                    placeholder="Additional information..."
                                                    no-resize
                                            ></b-form-textarea>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3">
                                        <b-col>
                                            <h4>INTERNAL ORDER REFERENCE
                                                <small>(Optional)</small>
                                            </h4>
                                            <b-form-input
                                                    id="reference"
                                                    name="reference"
                                                    type="text"
                                                    maxlength="30"
                                                    v-validate="'max: 30'"
                                                    v-model.trim="reference"
                                                    v-bind:class="[{'is-invalid': errors.has('reference')}]"
                                                    placeholder="Internal Order Reference"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="input-1-live-feedback">
                                                {{ errors.first('reference') }}
                                            </b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row class="mt-2">
                                    <b-col>
                                        <b-button variant="primary" class="btn-block my-2" @click="finalizeOrder">
                                            FINALIZE
                                            ORDER
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>
<script>


    import {mapActions, mapGetters, mapState} from "vuex";
    import ShoppingCartApi from "@shared/_api/shoppingCart";
    import CheckoutCartItem from "./CheckoutCartItem";
    import CartBase from "../Cart/CartBase";

    export default {
        name: 'cart-overview',
        extends: CartBase,
        props: {},
        components: {
            'checkout-cart-item': CheckoutCartItem
        },
        data() {
            return {
                preferredDeliveryDate: null,
                submitError: null,
                cartId: null,
                deliveryAddressSameAsBilling: true,
                deliveryAddress: {
                    recipient: null,
                    recipientSecondary: null,
                    street: null,
                    zipCode: null,
                    city: null,
                    country: null
                },
                busy: false,
                selectedDeliveryAddress: null,
                selectedAddressType: 'SELECT_ADDRESS',
                selectedSeason: null,
                selectedCountry: null,
                seasonList: [],
                countryList: [],
                orderComment: null,
                reference: null
            };
        },
        beforeRouteUpdate(to, from, next) {
            this.initCart(to.params.cartId);
            next();
        },
        mounted() {

        },
        created() {
            this.initCart(this.$route.params.cartId);

            this.busy = true;

            Promise.all([ShoppingCartApi.getSeasonlist(), ShoppingCartApi.getCountryList()])
                .then(([seasonList, countryList]) => {
                    this.seasonList = seasonList;
                    this.countryList = countryList

                }).finally(() => {

                this.busy = false;
            });
        },
        methods: {
            ...mapActions("cart", ["fetchCart"]),
            initCart: function (cartId) {
                this.cartId = Number(cartId);
            },
            onSelectDeliveryAddress(deliveryAddress) {

                this.deliveryAddress = {
                    recipient: deliveryAddress.name,
                    recipientSecondary: deliveryAddress.secondaryName,
                    street: deliveryAddress.street,
                    zipCode: deliveryAddress.zipCode,
                    city: deliveryAddress.city,
                    country: this.countryList.find(c => deliveryAddress.country === c.locale)
                };

                this.selectedDeliveryAddress = deliveryAddress;
            },
            finalizeOrder: function () {
                this.busy = true;

                this.submitError = null;

                let basicOrderInfo = {
                    deliveryAddressId: this.selectedDeliveryAddress ? this.selectedDeliveryAddress.id : null,
                    comment: this.orderComment,
                    deliveryAddressType: (this.deliveryAddressSameAsBilling === false) ? 'NEW' : 'COMPANY',
                    reference: this.reference,
                    orderType: 'REGULAR'
                };

                this.$validator.validate().then(valid => {
                    if (valid) {
                        let order = {
                            ...basicOrderInfo,
                            seasonId: this.selectedSeason.id,
                            recipient: (this.deliveryAddressSameAsBilling === false) ? this.deliveryAddress.recipient : this.user.firstName + " " + this.user.lastName,
                            recipientSecondary: (this.deliveryAddressSameAsBilling === false) ? this.deliveryAddress.recipientSecondary : this.user.externalData.company.companyName,
                            street: (this.deliveryAddressSameAsBilling === false) ? this.deliveryAddress.street : this.user.externalData.company.street,
                            zipCode: (this.deliveryAddressSameAsBilling === false) ? this.deliveryAddress.zipCode : this.user.externalData.company.zipCode,
                            city: (this.deliveryAddressSameAsBilling === false) ? this.deliveryAddress.city : this.user.externalData.company.city,
                            country: (this.deliveryAddressSameAsBilling === false) ? this.deliveryAddress.country.locale : this.user.externalData.company.country,
                            preferredDeliveryDate: this.preferredDeliveryDate
                        };

                        return ShoppingCartApi.checkout(this.cartId, order).then(() => {
                            this.$tracker.trackEvent({
                                label: 'Checkout Cart Value',
                                meta: this.$options.filters.currency(this.total, this.$currencyFormatting[this.currency]),
                                type: 'CHECKOUT_ORDER_REGULAR'
                            });
                            return this.fetchCart();
                        }).then(() => {
                            this.$router.push({name: 'checkout-success'})
                        }).catch(() => {
                            this.submitError = "An unexpected error occured processing your order. Please contact our customer support."
                        })
                    }
                    return Promise.resolve();
                }).finally(() => {
                    this.busy = false;
                });


            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            }
        },
        computed: {
            ...mapState("cart", ['loadingCart']),
            ...mapState('account', ['user']),
            ...mapGetters('cart', ['cartArray', 'itemArray', 'cartById']),
            cart: function () {
                return this.cartById(this.cartId);
            },
            deliveryAddressOptions() {

                return this.user.deliveryAddressList ? this.user.deliveryAddressList.map((i, idx) => {
                    return {...i, label: (idx + 1) + ". " + i.name}
                }) : []
            },
        },
        watch: {
            // whenever question changes, this function will run
            selectedAddressType: function (newType) {
                this.$validator.reset().finally(() => {
                    if (newType === 'SELECT_ADDRESS') {
                        if (this.user.deliveryAddressList && this.user.deliveryAddressList.length > 0) {
                            this.onSelectDeliveryAddress(this.user.deliveryAddressList[0]);
                        }
                    } else {
                        this.deliveryAddress = {
                            recipient: null,
                            recipientSecondary: null,
                            street: null,
                            zipCode: null,
                            city: null,
                            country: null
                        }
                    }
                });
            },
            cart: {
                handler: function (val) {
                    if(val) {
                        let orderIsOverStock = this.cart.shoppingCartItemList.find((itemId) => {
                            return this.itemArray[itemId].amount > this.itemArray[itemId].articlePrice.calculatedStock
                        });
                        this.preferredDeliveryDate = new Date();
                        if(orderIsOverStock) {
                            this.preferredDeliveryDate.setDate(this.preferredDeliveryDate.getDate() + 21 );
                        } else {
                            this.preferredDeliveryDate.setDate(this.preferredDeliveryDate.getDate() + 2 );
                        }
                    }
                },
                deep: true,
                immediate: true
            }
        },
    }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .cart-overview {

    }
</style>
